<div [formGroup]="form">
  <eop-form-input-item [required]="false" [title]="'EV_DRIVER_MANAGEMENT.EV_TARIFF' | translate">
    <emob-dropdown
      [items]="tariffItems"
      [loading]="loading"
      [placeholder]="'GLOBAL.PLEASE_SELECT' | translate"
      [searchable]="true"
      [singleSelectDeselactable]="false"
      [itemTemplate]="showPricingVisibility ? tariffWithPricingVisibilityTemplate : null"
      data-test="tariffs"
      formControlName="selectedTariff">
    </emob-dropdown>
  </eop-form-input-item>
  <div class="info-boxes">
    @if (noTariffsAvailable && !loading) {
      <info-box
        [text]="'EV_DRIVER_ACCOUNT.NO_TARIFF_AVAILABLE_INFO' | translate"
        [type]="InfoBoxType.WARNING"
        data-test="no-tariff-available-info"></info-box>
    }
    <eop-no-tariff-info></eop-no-tariff-info>
  </div>
</div>

<ng-template #tariffWithPricingVisibilityTemplate let-itemName="itemName" let-item="item">
  <div class="tariff-item template-item">
    <div
      class="item-name"
      [matTooltip]="itemName"
      matTooltipPosition="above"
      matTooltipShowDelay="1000">
      {{ itemName }}
    </div>
    <div class="item-icon item-addition">
      @if (item.value.pricingVisibility === EPricingVisibility.HIDE) {
        <eop-icon
          identifier="view-off"
          [weight]="IconWeight.LIGHT"
          [size]="IconSize.SMALL"
          [tooltip]="'ACCESS_CONTROL.PRICING_VISIBILITY_HIDDEN' | translate"></eop-icon>
      }
    </div>
  </div>
</ng-template>
